export function useNexusHelper(): {
    isNexusEntity: (entity: object) => boolean;
} {
    const isNexusEntity = (entity: object): boolean => {
        return 'nexusId' in entity && entity?.nexusId !== null;
    };

    return { isNexusEntity };
}
